import { put, take, select } from 'redux-saga/effects';
import {
  GET_USER_PAYMENT_INFOS_FAILURE,
  GET_USER_PAYMENT_INFOS_SUCCESS,
  GET_ZPP_COURSE_INFOS_FAILURE,
  GET_ZPP_COURSE_INFOS_SUCCESS,
  getUserSubscriptionsRequest,
  getZppCourseInfosRequest,
  setActiveUserSubscriptions
} from 'redux/actions';
import { getCurrentUser } from 'redux/query';

export function* loadUserSubscriptionsSaga() {
  yield put(getUserSubscriptionsRequest());
  const actionUserSubscription = yield take([GET_USER_PAYMENT_INFOS_SUCCESS, GET_USER_PAYMENT_INFOS_FAILURE]);

  if (actionUserSubscription.type === GET_USER_PAYMENT_INFOS_FAILURE) {
    console.error('User subscriptions loading failed', actionUserSubscription.error);
    return;
  }
  yield put(getZppCourseInfosRequest());
  const actionZppInfos = yield take([GET_ZPP_COURSE_INFOS_SUCCESS, GET_ZPP_COURSE_INFOS_FAILURE]);

  if (actionZppInfos.type === GET_ZPP_COURSE_INFOS_FAILURE) {
    console.error('User course info loading failed', actionZppInfos.error);
    return;
  }
  const state = yield select();
  const user = getCurrentUser(state);

  if (!user) {
    console.error('User or subscription plans not found in state');
    return;
  }

  const userSubscriptions = user?.subscriptions?.map(({ subscriptionPlan }) => subscriptionPlan) || [];

  yield put(setActiveUserSubscriptions({ subscriptions: userSubscriptions }));
}
